import { render, staticRenderFns } from "./reporte_gestionconvenio.vue?vue&type=template&id=0a34b4d4"
import script from "./reporte_gestionconvenio.vue?vue&type=script&lang=js"
export * from "./reporte_gestionconvenio.vue?vue&type=script&lang=js"
import style0 from "./reporte_gestionconvenio.vue?vue&type=style&index=0&id=0a34b4d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports